import React from 'react';
import { Table, Button } from 'reactstrap';
import moment from 'moment';
import Auth from '@src/components/Elements/Auth/Auth';

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <tbody>
        {props.list.map(item => {
          const createdDate = moment(item.created * 1000).format(
            'ddd, MM/DD/YYYY hh:mm A'
          );
          return (
            <tr key={'announcements-' + item.id}>
              <td style={{ wordBreak: 'break-word' }}>
                <div>
                  <div className={'font-xs color-menu-blue'}>
                    {createdDate} by {item.user.name}
                  </div>
                  <div className={'font-sm'} style={{ lineHeight: '18px' }}>
                    {item.body}
                  </div>
                </div>
              </td>
              <Auth action={'Annoucements::edit'}>
                <td style={{ width: '150px' }}>
                  <Button
                    color={'default'}
                    size={'sm'}
                    onClick={() => props.onEdit(item)}
                  >
                    Edit
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    color={'danger'}
                    size={'sm'}
                    onClick={() => props.onDelete(item)}
                  >
                    Delete
                  </Button>
                </td>
              </Auth>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
